// @flow
import React from "react";
import { noop } from "lodash";
import type { NullaryFn } from "@tvg/types/Functional";
import buildColor from "@fdr/static-ui/ColorPalette";
import Icon from "@fdr/static-ui/Icons";
import { warning, crossCircle } from "@fdr/static-ui/Icons/icons";
import type { IconType } from "@fdr/static-ui/Icons/Types.js.flow";
import {
  Container,
  InfoWrapper,
  InfoLogoWrapper,
  UpperIconWrapper,
  InfoContainer,
  InfoTitle,
  InfoMessage,
  Button
} from "./styled-components";

type Props = {
  icon: IconType,
  hasUpperIcon: boolean,
  upperIconType: "warning" | "error" | "bets",
  title: string,
  message: string,
  buttonText: ?"Clear filters" | "Refresh" | "Clear Filters",
  onClearFilters: NullaryFn<void>,
  fullWidth: boolean
};

const handleButtonClick = (buttonText, onClearFilters) => {
  if (buttonText === "Refresh") {
    location.reload();
  }
  if (buttonText === "Clear Filters" || buttonText === "Clear filters") {
    onClearFilters();
  }
};

const Info = ({
  icon,
  hasUpperIcon,
  upperIconType,
  title,
  message,
  buttonText,
  onClearFilters,
  fullWidth
}: Props) => (
  <Container>
    <InfoWrapper
      fullWidth={fullWidth}
      hasSeparator={!fullWidth && !!buttonText}
    >
      <InfoLogoWrapper fullWidth={fullWidth}>
        <Icon
          icon={icon}
          size={!fullWidth ? 18 : 24}
          qaLabel="InfoIcon"
          color={buildColor("grey", "D4")}
        />
        {hasUpperIcon && (
          <UpperIconWrapper fullWidth={fullWidth} upperIconType={upperIconType}>
            <Icon
              icon={upperIconType === "error" ? crossCircle : warning}
              size={10}
              qaLabel="WarningIcon"
              color={buildColor("white", "100")}
            />
          </UpperIconWrapper>
        )}
      </InfoLogoWrapper>
      <InfoContainer>
        <InfoTitle>{title}</InfoTitle>
        <InfoMessage>{message}</InfoMessage>
      </InfoContainer>
    </InfoWrapper>
    {buttonText && (
      <Button onClick={() => handleButtonClick(buttonText, onClearFilters)}>
        {buttonText}
      </Button>
    )}
  </Container>
);

Info.defaultProps = {
  icon: null,
  hasUpperIcon: false,
  upperIconType: "warning",
  title: "",
  message: "",
  buttonText: null,
  onClearFilters: noop,
  fullWidth: false
};

export default Info;
